import { render, staticRenderFns } from "./LoanTypesTable.vue?vue&type=template&id=07aa311c"
import script from "./LoanTypesTable.vue?vue&type=script&lang=js"
export * from "./LoanTypesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports